import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";

export function useArticle(articleId: string) {
	const query = useQuery({
		queryKey: ["article", articleId],
		queryFn: async () => {
			const response = await client.stock.articles[":articleId"].$get({
				param: { articleId },
			});
			const data = await responseHandler(response);
			return data.article;
		},
	});

	return { ...query, article: query.data };
}
